module.exports = __webpack_public_path__ + "e42fb981c0de31819c982a8f32864b0b.svg";